import styled from 'styled-components';
import { Text, Tag, Stack, VeeqoLogo as VLogo, theme } from '@veeqo/ui';

type Direction = 'horizontal' | 'vertical';

interface VeeqoLogoProps {
  tag?: string;
  direction?: Direction;
}

const GreenTag = styled(Tag)<{ direction: Direction }>`
  background-color: ${theme.colors.secondary.green.light};
  ${({ direction }) => {
    if (direction === 'horizontal') return 'margin-top: -6px'; // adjust alignment with logo
  }};
`;

const VeeqoLogo = ({ tag, direction = 'horizontal' }: VeeqoLogoProps) => {
  const spacing = direction === 'horizontal' ? 5 : 3;

  if (tag) {
    return (
      <Stack direction={direction} alignY="center" spacing={spacing}>
        <VLogo
          colorVariant="black"
          iconColor="#2578FF"
          style={{ width: '145px', marginRight: theme.sizes.md, marginBottom: theme.sizes.md }}
        />
        <GreenTag direction={direction}>
          <Text variant="bodySmall">{tag}</Text>
        </GreenTag>
      </Stack>
    );
  }

  return <VLogo colorVariant="black" iconColor="#2578FF" style={{ width: '145px' }} />;
};

export default VeeqoLogo;
